/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { DocumentDto } from './DocumentDto';
export type DownSavingPaymentDetailResponse = {
    txId: string;
    paymentChannelType?: DownSavingPaymentDetailResponse.paymentChannelType;
    qrUrl?: string;
    slipDocuments: Array<DocumentDto>;
    paymentCreatedBy?: string;
};
export namespace DownSavingPaymentDetailResponse {
    export enum paymentChannelType {
        CASH = 'CASH',
        PROMPT_PAY = 'PROMPT_PAY',
        PROMPT_PAY_QR = 'PROMPT_PAY_QR',
        BANK_ACCOUNT = 'BANK_ACCOUNT',
        AUTOMATIC_QR = 'AUTOMATIC_QR',
        TRUE_WALLET = 'TRUE_WALLET',
        CHILLPAY_QR = 'CHILLPAY_QR',
    }
}

